<script>

import { useToast } from "vue-toastification";
import MyPagination from '@/components/SystemElements/PaginationV2.vue'
import MyCountRecords from '@/components/SystemElements/CountRecordsOptionsV2.vue'

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";
Fancybox.bind("[data-fancybox]", {
  // Your options go here
});

//store
import {useSelectedItemStore} from "@/stores/selectedItem";

import UserCircle from '@/ui/UserCircle'


import TaskEdit from '@/components/CustomWorking/WorkingTasks/TaskEdit.vue'
import TaskDelete from '@/components/CustomWorking/WorkingTasks/TaskDelete.vue'

import TaskItemEdit from '@/components/CustomWorking/WorkingTasks/TaskItemEdit.vue'
import TaskItemDelete from '@/components/CustomWorking/WorkingTasks/TaskItemDelete.vue'

import LoadingScreen from '@/components/General/LoadingScreen'
import Alert from '@/components/General/Alert'

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';


//data
import { getTasks } from '@/services/working/serviceTask';

export default {
	setup() {
		let selectedItemStore = useSelectedItemStore();
		const allSelectedItems = selectedItemStore.getAllSelectedItems;

		const toast = useToast();
		return { toast, allSelectedItems, selectedItemStore }
	},
	name: 'Tasks',
	mixins: [ MixinGeneralFunct ],
	components: {
		TaskEdit,TaskDelete
		,TaskItemEdit,TaskItemDelete
		,UserCircle
		,MyPagination,MyCountRecords
		,LoadingScreen
		,Alert
	},
	props: {'auth':Object, 'secData':Object, 'params':Object},
	data() {
		return {
			prefix:'',
		
            
            metaData:[],
            
            isLoading:true,

            menuItems:[],
            actLangs:[],
            
            helpboxData: [],
            
            totalCount:0,
            dataList:[],
            selectedFilterText:'',
            
            selectedType:'',
            optionsTypes:[],

			selectedTaskId:'',
			selectedTaskItemId:'',

           
			selectedPage:1,
			selectedRecords:10,
			selectedCol:'a.id',
			selectedSort:'desc',
			
			checkAllItems:false,
						
		
			showFilter:false,
			filterExtended:true,
			
			showedHelpbox:false,

			modalDelete:{},
			modalDeleteId:'',
			
			modalEdit:{},
			modalEditId:'',

			modalDeleteItem:{},
			modalDeleteItemId:'',
			
			modalEditItem:{},
			modalEditItemId:'',
		}
	},
	
	mounted:function(){
		this.modalDeleteId = `modal${this.getRandomInt(999999999)}`;
		this.modalEditId = `modal${this.getRandomInt(999999999)}`;
		this.modalDeleteItemId = `modal${this.getRandomInt(999999999)}`;
		this.modalEditItemId = `modal${this.getRandomInt(999999999)}`;
	},
	
	methods: {
				
		onLoadPage:function(){
			
			//show loader
			this.isLoading=true

			getTasks({filterText: this.selectedFilterText, orderCol: this.selectedCol, orderSort: this.selectedSort, page: this.selectedPage, records: this.selectedRecords}).then(response => {
				console.log(response)
				if(!response.statusText){
					this.isLoading=false
					this.dataList = response.results;
					this.metaData = response.metaData;
					this.totalCount = response.totalCount;

					//oznacenie poloziek cez strankovac
					for(let i = 0; i < this.dataList.length; i++){
						if(this.allSelectedItems.indexOf(this.dataList[i].id)>=0){
							this.dataList[i].selectedId=true;
						}
					}
					
				}else{
					this.isLoading=false
					this.errorStatus=`${response.statusText} ${response.status}`
				}
			});
		
		},
		
				
		//(od)oznacenie vsetkych poloziek
		onCheckAllItems:function(){
			if(this.checkAllItems){
				for(let i = 0; i < this.dataList.length; i++){
					this.dataList[i].selectedId=true;
					if(this.allSelectedItems.indexOf(this.dataList[i].id)==-1){
						this.selectedItemStore.addSelectedItems(this.dataList[i].id);
					}
				}
			}else{
				for(let i = 0; i < this.dataList.length; i++){
					this.dataList[i].selectedId=false;
					var indexToRemove = this.allSelectedItems.indexOf(this.dataList[i].id);
					if(indexToRemove>=0){
						this.selectedItemStore.deleteSelectedItems(indexToRemove);
					}
				}
			}
		},
		
		//oznacenie jednej polozky
		onCheckItem:function(index,id){
			if(this.dataList[index].selectedId==true){
				this.selectedItemStore.addSelectedItems(id);
			}else{
				var indexToRemove = this.allSelectedItems.indexOf(id);
				this.selectedItemStore.deleteSelectedItems(indexToRemove);
			}
		},

		//zrusenie vyberu
		onResetSelected:function(){
			for(let i = this.allSelectedItems.length; i>=0 ;i--){
				var indexToRemove = this.allSelectedItems.indexOf(this.allSelectedItems[i]);
				if(indexToRemove>=0){
					var index = this.dataList.findIndex(item => item.id==this.allSelectedItems[i]); 
					if(index>=0){
						this.dataList[index].selectedId=false;
					}
					this.selectedItemStore.deleteSelectedItems(indexToRemove);
				}
			}
		},
		
		//radenie zoznamu - orders by
		orderByCol:function(col){
			
			if(col === this.selectedCol) {
				this.selectedSort = this.selectedSort==='asc'?'desc':'asc';
			}
			this.selectedCol = col;
			
			this.onLoadPage();
		},
		
		
		//active menu
		isActive: function (col) {
			return this.selectedCol === col;
		},
		isAsc: function (col) {
			if(this.selectedCol === col && this.selectedSort === 'asc'){
				return true;
			}
		},
		isDesc: function (col) {
			if(this.selectedCol === col && this.selectedSort === 'desc'){
				return true;
			}
		},
		
		//zobrazi filtre
		showFilters: function(){
			if(!this.showFilter) {
				this.showFilter = true;
			}else{
				this.showFilter = false;
			}
		},
		
		//vycisti text filter
		resetTextFilter: function(){
			this.selectedFilterText = '';
			this.onLoadPage();
		},
		
		// zobrazi napovedu
		showHelpbox: function(){
			if(!this.showedHelpbox) {
				this.showedHelpbox = true;
			}else{
				this.showedHelpbox = false;
			}
		},
		// systemove funkcie k zoznamu KONIEC
		
		
		//modal box  editacia
		loadModalFormTaskEdit:function(recordID){
			this.cSession();
			//console.log(recordID)
			this.selectedTaskId=String(recordID);
			this.modalEdit = new bootstrap.Modal(document.getElementById(this.modalEditId), {backdrop:'static'})
			this.modalEdit.show();
		},
		
		//modal box  delete
		loadModalFormTaskDelete:function(recordID){
			this.cSession();
			//console.log(recordID)
			this.selectedTaskId=String(recordID);
			this.modalDelete = new bootstrap.Modal(document.getElementById(this.modalDeleteId), {backdrop:'static'})
			this.modalDelete.show();
		},

		//modal box  editacia
		loadModalFormTaskItemEdit:function(taskId,taskItemId){
			this.cSession();
			//console.log(recordID)
			this.selectedTaskId=String(taskId);
			this.selectedTaskItemId=String(taskItemId);
			this.modalEditItem = new bootstrap.Modal(document.getElementById(this.modalEditItemId), {backdrop:'static'})
			this.modalEditItem.show();
		},
		
		//modal box  delete
		loadModalFormTaskItemDelete:function(recordID){
			this.cSession();
			//console.log(recordID)
			this.selectedTaskItemId=String(recordID);
			this.modalDeleteItem = new bootstrap.Modal(document.getElementById(this.modalDeleteItemId), {backdrop:'static'})
			this.modalDeleteItem.show();
		},
		
		

		
		//zmena zaznamu
		onChangeItem() {
			this.onLoadPage();
			this.selectedTaskId='';
			this.selectedTaskItemId='';
		},

		//vyber stranky v strankovaci
		onChangePage(selectedPage) {
			this.selectedPage=selectedPage
			this.onLoadPage();
		},

		//vyber poctu zaznamov
		onChangeRecords(selectedCount) {
			this.selectedPage=1;
			this.selectedRecords=selectedCount
			this.onLoadPage();
		},
		
				
	},	
	
			
	watch: {
		'auth.tasksList': function () {
			this.onLoadPage();
		}
	},

	computed:{
		
	},
	
}

</script>

<template>
	<div>

		<LoadingScreen :isLoading="isLoading"></LoadingScreen>
		<div id="version" class="version"><p>{{metaData.version}}</p></div>

		<div v-if="metaData.modulAccess" > 
					
            <div class="row">
                <div class="col-12">
                                    
					<div class="row">
						<div class="col-6">
							<h5>{{ $t('msgCustomWorking.Tasks') }}</h5>	 
						</div> 
						
						<div class="col-6 right">
							<button type="button" :disabled="!auth.tasksItemNew" v-on:click="loadModalFormTaskEdit(null)" class="btn btn-primary btn-sm"><i class="smire-icon fas fa-plus"></i> {{ $t('msgCore.btnAdd') }}</button>
						</div> 
					</div>

					<!-- filters basic -->
					<div class="row">
						<div class="input-group col-md-4 col-12">
							<button type="button" :title="$t('msgCore.btnFilter')" class="btn btn-info btn-sm my-btn" v-on:click="showFilters()">
								<span v-if="filterExtended">
									<i v-if="!showFilter" class="smire-icon fas fa-search-plus"></i> 
									<i v-else class="smire-icon fas fa-search-minus"></i>
								</span>
								<span v-else>
									<i class="smire-icon fas fa-search"></i> 
								</span>
								{{ $t('msgCore.btnFilter') }}
							</button>
							<input type="text" class="form-control form-control-sm" v-model='selectedFilterText' :placeholder="$t('msgCore.searchTitle')" v-on:change="onLoadPage()">
							<button type="button" :title="$t('msgCore.btnStorno')" class="btn btn-outline-info btn-sm my-btn" v-on:click="resetTextFilter()">
								<i class="smire-icon fas fa-times"></i>
							</button>
						</div>
					</div>
					
					
					<!-- filters extended -->
					<div v-show="showFilter && filterExtended" class="row">
						<div class="input-group form-group-filter col-4">
					
							<select v-model='selectedType' class="form-control form-control-sm" v-on:change="onLoadPage()">
								<option value="">{{ $t('msgCore.selectType') }}</option>
								<option v-for="(options) in optionsTypes" :value="options.value" :key="options.value">{{ options.title }}</option>
							</select>
							
						</div>					
					</div>
                        
                    
                </div>
            </div>	

            
            <!-- zakladny zoznam -->
            <div v-if="totalCount>0">

				<div class="row">
					<div class="col-12">
	
						<div class="table-responsive">
							<table class="table table-hover table-sm">
							
								<thead>
									<tr>
										<th class="orderBy" v-on:click="sort('id')" :class="{ active: isActive('id'), asc: isAsc('id'), desc: isDesc('id')}">id</th>

										<th width="10" class="align-middle">
												<div class="form-check">
													<label class="form-check-label">
													<input v-model="checkAllItems" v-on:change="onCheckAllItems()" class="form-check-input" type="checkbox">
													<span class="form-check-sign">
														<span class="check"></span>
													</span>
													</label>
												</div>
											</th>
										

										<th>
											
											{{$t('msgCore.action')}}
										</th>
										
										<th>{{$t('msgCore.Project')}}</th>
										
										<th>{{$t('msgCore.title')}}</th>
										
										<th>{{$t('msgCore.description')}}</th>
										
										<th>{{$t('msgCore.Status')}}</th>
										
										
										
										<th>{{$t('msgCore.Type')}}</th>
										
										<th v-if="auth.tasksItemNew">{{$t('msgCore.Time')}}</th>
										
										<th v-if="auth.tasksItemNew">{{$t('msgCore.Price')}}</th>
										
										<th v-if="auth.tasksItemNew">{{$t('msgCore.Price')}} celkom</th>	

										<th>{{$t('msgCore.Created')}}</th>
                                            
                                        <th>{{$t('msgCore.Modified')}}</th>									
									</tr>
								</thead>
								
							<tbody v-for="(basicObj, index) in dataList" :key="basicObj" >	
								<tr>
								
									<td class="blue">{{ basicObj.id }}</td>

									<td class="align-middle">
											<div class="form-check">
												<label class="form-check-label">
												<input v-model.number='basicObj.selectedId' class="form-check-input" type="checkbox" v-on:change="onCheckItem(index,basicObj.id);">
												<span class="form-check-sign"><span class="check"></span></span>
												</label>
											</div>	
										</td>
								
									<td class="align-middle">
										<div class="input-group">	
											
												
																				
											<div class="btn-group">				
												<button type="button" :disabled="!auth.tasksEdit" v-on:click="loadModalFormTaskEdit(basicObj.id)" :title="$t('msgCore.btnEdit')" id="myModalBtn" class="btn btn-secondary btn-sm"><i class="fas fa-edit"></i></button>
										
												<button :disabled="!auth.tasksDelete" type="button"  v-on:click="loadModalFormTaskDelete(basicObj.id)" :title="$t('msgCore.btnDelete')" id="myModalBtn" class="btn btn-danger btn-sm"><i class="fas fa-trash-alt"></i></button>
														
												<button v-if="auth.tasksItemNew" type="button"  v-on:click="loadModalFormTaskItemEdit(basicObj.id,null)" :title="$t('msgCore.btnAdd')" id="myModalBtn" class="btn btn-primary btn-sm"><i class="fas fa-plus"></i></button>				
											</div>	
										</div>	
									</td>
													
									<td class="blue" >{{ basicObj.project_name }}</td>							
									
									<td class="blue">{{ basicObj.title }}</td>
									
									<td class="blue" >{{ basicObj.description }}</td>
									
									<td ><span class="badge " :class="basicObj.status_color">{{ $t('msgCustomWorking.'+basicObj.status_name) }}</span></td>
									
									
								
									<td class="blue" >{{ $t('msgCustomWorking.'+basicObj.type_name) }}</td>
									
									
									
									<td v-if="auth.tasksItemNew" class="blue" ><span class="green">{{ basicObj.totalTimePaid }}</span>/<span class="red">{{ basicObj.totalTimeFree }}</span> min</td>
									
									<td v-if="auth.tasksItemNew"></td>
									
									<td v-if="auth.tasksItemNew" class="blue" ><span class="green">{{ basicObj.totalPricePaid  }}</span>/<span class="red">{{ basicObj.totalPriceFree  }}</span> €</td>

										<td>
											<UserCircle :firstName="basicObj.creatorFirstName" :surName="basicObj.creatorSurName" :color="basicObj.creatorColor" :date="basicObj.created"/>
                                        </td>

										<td>
											<UserCircle :firstName="basicObj.editorFirstName" :surName="basicObj.editorSurName" :color="basicObj.editorColor" :date="basicObj.modified"/>
                                        </td>
									
								</tr>
								<tr  v-for="(taskItem,) in basicObj.taskItems" :key="taskItem" >
									<td colspan="2">{{ basicObj.id }} - {{ taskItem.id }}</td>
									<td >
									
										<div class="btn-group">				
											<button type="button" :disabled="basicObj.isClosed"  v-on:click="loadModalFormTaskItemEdit(basicObj.id,taskItem.id)" :title="$t('msgCore.btnEdit')" id="myModalBtn" class="btn btn-secondary btn-sm"><i class="fas fa-edit"></i></button>
									
											<button type="button" :disabled="basicObj.isClosed"  v-on:click="loadModalFormTaskItemDelete(taskItem.id)" :title="$t('msgCore.btnDelete')" id="myModalBtn" class="btn btn-danger btn-sm"><i class="fas fa-trash-alt"></i></button>
										</div>
										
									</td>
									
									<td ><span class="badge" :class="taskItem.type_color">{{ $t('msgCustomWorking.'+taskItem.type_name) }}</span></td>
									
									<td >{{ taskItem.title }}</td>
									<td >{{ taskItem.description }}</td>
									
									
									<td ><span class="badge" :class="taskItem.status_color">{{ $t('msgCustomWorking.'+taskItem.status_name) }}</span></td>
									
									
									<td></td>
									
									<td >{{ taskItem.work_time }} min</td>
									<td >{{ taskItem.price }} €/hod</td>
									<td >{{ taskItem.editTime }} hod = {{ taskItem.realPrice }} €</td>
									
									<td>
										<UserCircle :firstName="taskItem.creatorFirstName" :surName="taskItem.creatorSurName" :color="taskItem.creatorColor" :date="taskItem.created"/>
									</td>

									<td>
										<UserCircle :firstName="taskItem.editorFirstName" :surName="taskItem.editorSurName" :color="taskItem.editorColor" :date="taskItem.modified"/>
									</td>
								</tr>	
							</tbody>
							
							</table>	
						</div>		
					
					</div>
				</div>

				<div class="row row-pagination">
					<div class="col-6 col-md-3 col-lg-2">
						<MyCountRecords :selectedRecords="selectedRecords" @onSelectRecords="onChangeRecords"></MyCountRecords>
					</div>
					
					<div class="col-6 col-md-3 col-lg-2 box-flex">
						<span>Počet: {{totalCount}} <button v-if="allSelectedItems.length>0" type="button" @click="onResetSelected()" class="btn btn-sm btn-info">Vybr.:{{ allSelectedItems.length }} <i class="fas fa-times"></i></button></span>
					</div>
					
					<div class="col-12 col-md-6 col-lg-8">	
						<MyPagination :selectedRecords="selectedRecords" :totalCount="totalCount" :selectedPage="selectedPage" @onSelectPage="onChangePage"></MyPagination>
					</div>
				</div>
                    
                
            </div>	
            
            <div v-else class="row">
                <div class="col-12 mt-3">
					<Alert type="warning" :label="$t('msgCore.forThisSelectExistAnyData')" />
				</div>								
            </div>
            
        </div>	
        
        <div v-else class="container-fluid">
            <div class="row">
				<div class="col-12 mt-3">
					<Alert type="warning" :label="$t('msgCore.accessDenied')" />
                </div>
            </div>
        </div>
	
		<TaskEdit :auth="auth" :secData="secData" :taskId="selectedTaskId" @changeRecord="onChangeItem" :modalObject="modalEdit" :modalId="modalEditId"></TaskEdit>
		<TaskDelete :auth="auth" :secData="secData" :taskId="selectedTaskId" @changeRecord="onChangeItem" :modalObject="modalDelete" :modalId="modalDeleteId"></TaskDelete>

		<TaskItemEdit :auth="auth" :secData="secData" :taskItemId="selectedTaskItemId" :taskId="selectedTaskId" @changeRecord="onChangeItem" :modalObject="modalEditItem" :modalId="modalEditItemId"></TaskItemEdit>
		<TaskItemDelete :auth="auth" :secData="secData" :taskItemId="selectedTaskItemId" @changeRecord="onChangeItem" :modalObject="modalDeleteItem" :modalId="modalDeleteItemId"></TaskItemDelete>
	</div>	
		
</template>


